import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MapPin, Plus, Trash2 } from "lucide-react";

const AdditionalPropertiesSection = ({
  additionalProperties,
  newPropertyAddress,
  onNewPropertyAddressChange,
  onAddProperty,
  onRemoveProperty,
}) => {
  return (
    <div className="border-t border-zinc-200 pt-4 mt-4">
      <Label className="text-sm font-medium text-zinc-700 mb-2 block">Additional Properties (Optional)</Label>
      
      {additionalProperties.length > 0 && (
        <div className="space-y-2 mb-3">
          {additionalProperties.map((prop, index) => (
            <div key={prop.pin || prop.address || index} className="flex items-center gap-2 p-3 bg-zinc-50 rounded-lg border border-zinc-200">
              <MapPin className="w-4 h-4 text-zinc-400 flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-zinc-900 truncate">{prop.address}</p>
                {prop.pin && <p className="text-xs text-zinc-500">PIN: {prop.pin}</p>}
              </div>
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemoveProperty(index)}
                className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8 w-8 p-0"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
      
      <div className="flex gap-2">
        <Input
          value={newPropertyAddress}
          onChange={(e) => onNewPropertyAddressChange(e.target.value)}
          placeholder="Enter additional property address"
          className="h-10 bg-zinc-50/50 flex-1"
          name="lcc-add-prop-loc"
          autoComplete="off"
          autoCorrect="off"
          spellCheck={false}
          data-lpignore="true"
          data-1p-ignore="true"
          data-bwignore="true"
          data-form-type="other"
          data-testid="additional-property-input"
        />
        <Button
          type="button"
          variant="outline"
          onClick={onAddProperty}
          disabled={!newPropertyAddress.trim()}
          className="h-10"
          data-testid="add-property-button"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add
        </Button>
      </div>
      <p className="text-xs text-zinc-500 mt-1">Add multiple properties if this quote covers more than one location</p>
    </div>
  );
};

export default AdditionalPropertiesSection;
